export default __webpack_public_path__ + "static/media/success.9ba8782f.svg";